import Component from '../../js/_Component';
import ResizeClasses from '../../js/util/_ResizeClasses';

const CNAME = 'c-block-promos-simple';

export default class BlockPromosSimple extends Component {
	constructor(element: HTMLElement) {
		super(element);

		new ResizeClasses(this.element, {
			'm-hide-background': {
				max: 768,
			}
		})
	}
}

Component.register(BlockPromosSimple, 'BlockPromosSimple');
